import * as React from "react";

interface Props {
    nameWidth: number;
    valueWidth: number;
    data: { name: string, value: any };
}

const DataRow: React.SFC<Props> = (props) => {
    const { nameWidth, valueWidth, data } = props;

    return (
        <div className="row">
            <div className={`col-sm-${nameWidth}`}>
                <strong>{data.name}</strong>
            </div>
            <div className={`col-sm-${valueWidth}`}>
                {data.value}
            </div>
        </div>
    );
};

export default DataRow;


// WEBPACK FOOTER //
// ./src/components/DataRow.tsx